var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_4014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3184 21.6621C42.4148 22.1356 42.4655 22.6253 42.4655 23.127V24.5918H66.0007V21.6621H42.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5352 23.127C39.5352 20.7038 37.5638 18.7324 35.1406 18.7324H16V55.5488H24.8867V43.8301H57.1133V55.5488H66V27.5215H39.5352V23.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8164 67.2676H54.1836V46.7598H27.8164V67.2676ZM45.3945 58.4785H48.3242V61.4082H45.3945V58.4785ZM39.5352 58.4785H42.4648V61.4082H39.5352V58.4785ZM33.6758 52.6191H36.6055V61.4082H33.6758V52.6191Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_4014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(16 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileName);
export default __webpack_public_path__ + "static/media/FileName.8cfbc59f4fde7cb9fa0b63d58271c5d7.svg";
export { ForwardRef as ReactComponent };